import React from 'react';
import GenericInternalTransfer from '../GenericInternalTransfer';

const FlexiInternalTransfer = () => (
  <GenericInternalTransfer
    sectionName="Flexi Section"
    sectionKey="Flexi"
    backRoute="/sections/flexi"
  />
);

export default FlexiInternalTransfer;
